import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { formatDateTime } from '../lib/format';

export function AuditPage() {
  const list = useQuery({
    queryKey: ['audit'],
    queryFn: () => api.listAudit({ page: 1, page_size: 100 }),
  });

  return (
    <>
      <div className="card" style={{ padding: 0 }}>
        <table>
          <thead>
            <tr>
              <th style={{ width: 180 }}>When</th>
              <th style={{ width: 180 }}>Who</th>
              <th style={{ width: 140 }}>Action</th>
              <th style={{ width: 120 }}>Entity</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {list.isLoading ? (
              <tr>
                <td colSpan={5} style={{ textAlign: 'center', padding: '2rem' }}>
                  Loading…
                </td>
              </tr>
            ) : (list.data?.items ?? []).length === 0 ? (
              <tr>
                <td colSpan={5} style={{ textAlign: 'center', padding: '2rem' }}>
                  No audit entries yet.
                </td>
              </tr>
            ) : (
              list.data!.items.map((entry) => (
                <tr key={entry.id}>
                  <td style={{ color: 'var(--muted)' }}>{formatDateTime(entry.at)}</td>
                  <td>{entry.actor_email ?? '—'}</td>
                  <td>
                    <span className="badge">{entry.action}</span>
                  </td>
                  <td>
                    {entry.entity}
                    {entry.entity_id ? <span style={{ color: 'var(--muted)' }}> #{entry.entity_id}</span> : null}
                  </td>
                  <td style={{ fontFamily: 'ui-monospace, monospace', fontSize: '0.85rem' }}>
                    {entry.diff ? (
                      <code style={{ whiteSpace: 'pre-wrap' }}>{JSON.stringify(entry.diff, null, 0)}</code>
                    ) : (
                      '—'
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
